import { Box, Flex, Heading, Text, useBreakpointValue } from '@chakra-ui/react';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import React from 'react';
import { useInView } from 'react-intersection-observer';

type Props = {
  isReverse?: boolean;
  lead?: string;
  title: string;
  children: React.ReactNode;
  animationData: any;
  alternativeImage: string;
};

const DynamicLottie = dynamic(() => import(`react-lottie`));

const TextWithLottie = ({
  isReverse,
  title,
  lead,
  children,
  animationData,
  alternativeImage,
}: Props) => {
  const { ref, inView } = useInView({
    threshold: 0,
  });
  const isMobile = useBreakpointValue([true, true, false, false]);
  return (
    <Flex
      className="boxed-container"
      as="section"
      align="center"
      justify="center"
      pb="10"
      mt={[16, null, 0]}
      direction={
        [
          `column-reverse`,
          null,
          null,
          `row${isReverse ? `-reverse` : ``}`,
        ] as any
      }
    >
      <Flex flex={1} direction="column">
        {lead && (
          <Text mb={1} fontSize={[`md`, null, `2xl`]} color="brand.400">
            {lead}
          </Text>
        )}
        <Heading mb="9" as="h2" size="2xl">
          {title}
        </Heading>
        {children}
      </Flex>
      <Box
        ref={ref}
        px={[null, null, 10]}
        flex={1}
        w={[`full`, null, null, `lg`]}
        h={[`full`, null, null, `lg`]}
      >
        {inView && !isMobile ? (
          <DynamicLottie
            isClickToPauseDisabled
            style={{ cursor: `default`, flex: 1 }}
            options={{ animationData, loop: true, autoplay: true }}
          />
        ) : (
          <Image src={alternativeImage} width={512} height={512} alt={title} />
        )}
      </Box>
    </Flex>
  );
};

export default TextWithLottie;
